import React, {Component} from "react";
import {connect} from "react-redux";
import _ from "underscore";
import {$} from "../../index";
import {preloaderHide, preloaderShow} from "../../libs/redux/actions/preloader";
import {api, apis, errors, msg, rd, sendGet, throws, type_ment} from "../../vars/rd";
import DaoCategory from "../../modules/dao/category";
import DaoMent from "../../modules/dao/ment";
import MentItem from "../components/elements/ment.item";
import {$shutils} from "../../libs/snnh/snnh";

class Broadcast extends Component {
    mounted = false;
    scheduleRef = null;
    scheduleListRef = null;
    iconArrowRef = null;
    constructor(props) {
        super(props);

        const today = new Date();
        const today_str = `${$shutils.toDateShort(today, true)} ${$shutils.toWeekString(today, true)}요일`;

        /**
         *
         * @type {{today_version: string, today: DaoMent[], event_version: string, event: DaoMent[], category: DaoCategory[]}}
         */
        this.state = {
            today_str,
            today_version: null,
            today_count: 0,
            today_am: [],
            today_pm: [],

            event_version: null,
            event: [],
            event_exists: false,

            category_selected: null,
            category: [],
        };
    }

    async componentDidMount() {
        this.mounted = true;
        await this.data();
    }

    componentWillUnmount() {
        this.mounted = false;
        this.scheduleRef = null;
        this.scheduleListRef = null;
        this.iconArrowRef = null;
    }

    get dispatch() {
        return this.props.hasOwnProperty("dispatch") ? this.props.dispatch : () => {};
    }

    setScheduleRef(ref) {
        this.scheduleRef = ref;
    }

    setScheduleListRef(ref) {
        this.scheduleListRef = ref;
    }

    setIconArrowRef(ref) {
        this.iconArrowRef = ref;
    }

    toggleSchedule() {
        if(window.innerWidth > 767 || !this.mounted) return;

        $(this.scheduleListRef).stop().slideToggle(300);
        $(this.iconArrowRef).toggleClass("rotate");
        $(this.scheduleRef).toggleClass("open");
    }

    async data() {
        this.dispatch(preloaderShow());
        try {
            const url = api(apis.ment, {
                groupid: rd.user.groupid,
                serviceid: rd.user.serviceid,
            });
            const json = await sendGet(url);
            if(this.mounted) {
                if(!json || json.result !== "OK") throws(msg().api_fail);
                if(json.status === "OK") {
                    const category_selected = "AL";
                    const category = [
                        new DaoCategory({
                            proid: category_selected,
                            parid: category_selected,
                            code: category_selected,
                            proname: "전체"
                        })
                    ];
                    if(json.hasOwnProperty("category")) {
                        _.keys(json.category).forEach(key => {
                            category.push(new DaoCategory({
                                proid: key,
                                parid: key,
                                code: key,
                                proname: json.category[key]
                            }));
                        })
                    }

                    let event = [];
                    let event_version = null;
                    if(json.hasOwnProperty("event")) {
                        if(json.event.hasOwnProperty("version")) {
                            event_version = json.event.version;
                        }

                        if(json.event.hasOwnProperty("list") && json.event.list.length > 0) {
                            json.event.list.forEach(event_json => {
                                event.push(new DaoMent(event_json));
                            });
                        }
                    }
                    const event_exists = event.length > 0;

                    let today_am = []; // 오전편성
                    let today_pm = []; // 오후편성
                    let today_count = 0;
                    let today_version = null;
                    if(json.hasOwnProperty("today")) {
                        if(json.today.hasOwnProperty("version")) {
                            today_version = json.today.version;
                        }

                        if(json.today.hasOwnProperty("list") && json.today.list.length > 0) {
                            json.today.list.forEach(today_json => {
                                const ment = new DaoMent(today_json);
                                if(ment.is_pm) today_pm.push(ment);
                                else today_am.push(ment);
                                today_count++;
                            });
                        }
                    }

                    this.setState({
                        event_version,
                        event,
                        event_exists,

                        today_version,
                        today_count,
                        today_am: _.sortBy(today_am, 'datetime'),
                        today_pm: _.sortBy(today_pm, 'datetime'),

                        category_selected,
                        category
                    });
                }
            }
        } catch (e) {
            errors(e);
        } finally {
            this.dispatch(preloaderHide());
        }
    }

    /**
     *
     * @param category {DaoCategory}
     */
    category(category) {
        if(category) {
            let event_exists = false;
            const category_selected = category.code;
            (this.state.event || []).forEach(
                /**
                 * @param ment {DaoMent}
                 */
                ment => {
                    if(ment.is_match(category_selected)) event_exists = true;
                }
            );

            this.setState({category_selected, event_exists});
        }
    }

    render() {
        return (
            <div className="contents broadcast">
                <div className="left">
                    <div className="schedule" ref={el => this.setScheduleRef(el)}>
                        <div className="title-wrap">
                            <h2>오늘의 편성표</h2>
                            <h3>{this.state.today_count || 0}개 방송 · {this.state.today_str || ''}</h3>
                            <span className="mobile-only icon-arrow" ref={el => this.setIconArrowRef(el)} onClick={() => this.toggleSchedule()}><img src="/images/icon-arrow-w.png" alt=""/></span>
                        </div>
                        <div className="schedule-list" ref={el => this.setScheduleListRef(el)}>

                        {/* 오전멘트 */}
                            {
                                this.state.today_am.length ?
                                    <div className="section">
                                        <h4 className="am">AM</h4>
                                        <ul>
                                            {
                                                this.state.today_am.map(
                                                    /**
                                                     * @param ment {DaoMent}
                                                     * @param index {number}
                                                     * @returns {JSX.Element}
                                                     */
                                                    (ment, index) => {
                                                        return <MentItem data={ment} type={type_ment.today} key={index}  />;
                                                    }
                                                )
                                            }
                                        </ul>
                                    </div> :
                                    null
                            }

                            {/* 오후멘트 */}
                            {
                                this.state.today_pm.length ?
                                    <div className="section">
                                        <h4 className="pm">PM</h4>
                                        <ul>
                                            {
                                                this.state.today_pm.map(
                                                    /**
                                                     * @param ment {DaoMent}
                                                     * @param index {number}
                                                     * @returns {JSX.Element}
                                                     */
                                                    (ment, index) => {
                                                        return <MentItem data={ment} type={type_ment.today}
                                                                         key={index}/>;
                                                    }
                                                )
                                            }
                                        </ul>
                                    </div> :
                                    null
                            }
                        </div>
                    </div>
                </div>
                <div className="right">
                    <div className="section">
                        <div className="broad-list">
                            <h1>모든 안내멘트</h1>
                            <div className="schedule-tab">
                                <ul>
                                    {
                                        (this.state.category || []).map(
                                            /**
                                             * @param category {DaoCategory}
                                             * @param key {number}
                                             * @returns {JSX.Element}
                                             */
                                            (category, key) => {
                                                return <li key={key} className={this.state.category_selected === category.code ? 'on' : ''}
                                                           onClick={() => this.category(category)}>{category.proname}</li>
                                            }
                                        )
                                    }
                                </ul>
                            </div>
                            <div className="schedule-list">
                                {
                                    (this.state.event || []).map(
                                        /**
                                         * @param event_ment {DaoMent}
                                         * @param index {number}
                                         */
                                        (event_ment, index) => {
                                            if(event_ment.is_match(this.state.category_selected)) {
                                                return <MentItem key={index} data={event_ment} type={type_ment.default}  />;
                                            } else {
                                                return null;
                                            }
                                        }
                                    )
                                }

                                {
                                    !this.state.event_exists ?
                                        <div className="item empty">{msg().empty_ment}</div> : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect()(Broadcast);


// WEBPACK FOOTER //
// ./src/pages/broadcast/index.jsx